import cashClosureHistoryApi from "../../api/cash/cashClosureHistoryApi";

export interface CashClosureHistoryFilters {
    branchId?: number;
    registerId?: number;
    fromDate?: string; // yyyy-MM-dd
    toDate?: string; // yyyy-MM-dd
}

const CashClosureHistoryService = {

    /**
     * 📚 Obtener historial de cierres de caja (Corte Z)
     * POST /api/cash/closures/history/search
     */
    search: async (
        filters: CashClosureHistoryFilters,
        page = 0,
        size = 10
    ) => {

        const response =
            await cashClosureHistoryApi.addCustom(
                `/search?page=${page}&size=${size}`,
                filters
            );

        return response.data;

    },

};

export default CashClosureHistoryService;
